import { ButtonProps } from "antd";
import { ButtonStyled } from "./styles";

interface ButtonStyledProps extends ButtonProps {
  tooltip?: boolean;
}

const Button: React.FC<ButtonStyledProps> = (props) => (
  <ButtonStyled {...props}>{props.children}</ButtonStyled>
);

export default Button;
